import React from "react";
import { connect } from "react-redux";
import QuizItem from "./QuizItem/QuizItem";
import classes from "./QuizItems.module.css";
import * as actions from "../../../store/actions";
import ErrorHandler from "../../hoc/ErrorHandler/ErrorHandler";

const MODULES = {
  python: {
    logo: "fab fa-python fa-5x",
    text: "Python",
  },
  javascript: {
    logo: "fab fa-js-square fa-5x",
    text: "JavaScript",
  },
  htmlcss: {
    logo: "fas fa-code fa-5x",
    text: "HTML & CSS",
  },
  react: {
    logo: "fab fa-react fa-5x",
    text: "React",
  },
};

const QuizItems = (props) => {
  const { onFetchQuestions, history } = props;

  const moduleHandler = (module) => {
    onFetchQuestions(module);
    history.push("/test");
  };

  const quizItems = Object.keys(MODULES).map((module) => (
    <QuizItem
      key={module}
      selectModule={moduleHandler}
      moduleValues={MODULES[module]}
      moduleName={module}
    />
  ));

  return (
    <>
      <div className={classes.QuizItems}>{quizItems}</div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.questionsState.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchQuestions: (moduleName) =>
      dispatch(actions.fetchQuestionsInit(moduleName)),
    onClearError: () => dispatch(actions.questionsClearError()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorHandler(QuizItems));
